module.exports = __webpack_public_path__ + "img/google_cash.1fc75640.png";